import React, { forwardRef } from "react";

import { cn } from "../cn";

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement> & {
  error?: boolean;
};

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea({ className, error, ...props }, ref) {
  return (
    <textarea
      ref={ref}
      aria-invalid={error || undefined}
      className={cn(
        "tw-flex tw-min-h-20 tw-w-full tw-appearance-none tw-rounded-md tw-border tw-border-solid tw-bg-input",
        "tw-px-3 tw-py-2 tw-font-sans tw-text-sm tw-text-foreground tw-shadow-xs tw-transition-colors",
        "placeholder:tw-text-muted-foreground",
        "focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-offset-2 focus-visible:tw-ring-offset-background",
        "disabled:tw-cursor-not-allowed disabled:tw-opacity-50",
        error ? "tw-border-destructive-border focus-visible:tw-ring-ring-error" : "tw-border-border focus-visible:tw-ring-ring",
        className,
      )}
      {...props}
    />
  );
});
